import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import type { RoutingPipelineBlock } from '../../models/routing-ruleconfig1.models';

@Component({
  selector: 'app-routing-pipeline-left-panel',
  templateUrl: './routing-pipeline-left-panel.component.html',
  styleUrls: ['./routing-pipeline-left-panel.component.scss'],
  host: { class: 'routing-pipeline-left card vt-card' },
})
export class RoutingPipelineLeftPanelComponent {
  @Input() pipelineBlocks: RoutingPipelineBlock[] = [];
  @Input() totalPipelineCount: number | null = null;
  @Input() selectedPipelineId: string | null = null;
  @Input() leftPipelineSearchForm!: FormGroup;
  @Input() leftPipelineRouteNameList: { id: string; displayname: string }[] = [];
  @Input() isPipelineLeftSearchLoading = false;
  @Input() leftPipelineNotFound = false;
  @Input() pipelineKeyword = 'displayname';

  @Output() pipelineBlockSelect = new EventEmitter<RoutingPipelineBlock>();
  @Output() addNewPipeline = new EventEmitter<void>();
  @Output() pipelineSearchInput = new EventEmitter<unknown>();
  @Output() pipelineSearchSelected = new EventEmitter<{ id?: string; displayname?: string }>();
  @Output() pipelineSearchCleared = new EventEmitter<void>();

  /**
   * Returns the display label for a pipeline block in the left panel list.
   * @example block { id: 'pipe-1', label: 'Inbound HL7' } → 'Inbound HL7'
   */
  getPipelineBlockLabel(block: RoutingPipelineBlock): string {
    return (block?.label ?? block?.id ?? '').toString();
  }

  /**
   * Formats a route name suggestion for the pipeline search autocomplete.
   * @example formatPipelineSuggestion('Result Outbound Route') → 'Result Outbound Route'
   */
  formatPipelineSuggestion(displayname: string): string {
    return (displayname ?? '').toString();
  }
}
